import { jsx } from '@emotion/core';
import { Card } from '../Card';
import Type from '../Type';
import { useLocalization } from '../../localization';
import * as translations from './localization';
import { MARGIN, PADDING } from '../../constants';
import { facepaintMediaQueries } from '../shared';
var MAX_CONTEXT_WIDTH = 420;
var contentWrapperStyles = {
  maxWidth: MAX_CONTEXT_WIDTH
};
var h3Styles = facepaintMediaQueries({
  textAlign: 'center',
  marginBottom: [MARGIN.tiny, MARGIN.tiny, MARGIN.small]
});
var cardStyles = facepaintMediaQueries({
  display: 'flex',
  justifyContent: 'center',
  padding: [PADDING.tiny, PADDING["default"], PADDING.big]
});
var paragraphStyles = facepaintMediaQueries({
  textAlign: 'center',
  marginBottom: 0
});
export var MissingPermission = function MissingPermission() {
  var strings = useLocalization(translations).strings;
  return jsx(Card, {
    css: cardStyles
  }, jsx("div", {
    css: contentWrapperStyles
  }, jsx(Type.H3, {
    css: h3Styles
  }, strings.missingPermission), jsx(Type.Paragraph, {
    css: paragraphStyles
  }, strings.contactAdministration)));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MissingPermission/index.js
// module id = 1223
// module chunks = 0